import React from "react";
import ProductListPage from "./ProductListPage";
import { api } from "../lib/api";
import { useShop } from "../lib/shop-context";

/**
 * Phase 30 — /nuevo (also mapped as /novedades for backwards compatibility).
 * Phase 32 — scoped to the current shop.
 */
export default function Novedades() {
  const shopCtx = useShop();
  const shop = shopCtx?.shop || "envio";
  return (
    <ProductListPage
      title="Novedades"
      subtitle="Los últimos productos que han llegado a MercaGo"
      testid="novedades-page"
      emptyMessage="Sin novedades por ahora. Vuelve pronto — actualizamos el catálogo cada semana."
      fetchFn={() =>
        api
          .get("/products/new", { params: { limit: 100, shop } })
          .then((r) => r.data)
      }
    />
  );
}
